import { useState } from 'react';
import { uploadImage, generateFilePath, deleteImage } from '../services/imageUploadService';

interface UseImageUploadResult {
  uploading: boolean;
  error: string | null;
  upload: (file: File, folder: string) => Promise<string | null>;
  remove: (url: string) => Promise<void>;
}

export const useImageUpload = (): UseImageUploadResult => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const upload = async (file: File, folder: string): Promise<string | null> => {
    setUploading(true);
    setError(null);
    try {
      const path = generateFilePath(folder, file.name);
      const url = await uploadImage(file, path);
      return url;
    } catch (err) {
      console.error('Upload failed:', err);
      setError('Falha ao fazer upload da imagem');
      return null;
    } finally {
      setUploading(false);
    }
  };

  const remove = async (url: string): Promise<void> => {
    setUploading(true);
    setError(null);
    try {
      await deleteImage(url);
    } catch (err) {
      console.error('Delete failed:', err);
      setError('Falha ao remover imagem');
    } finally {
      setUploading(false);
    }
  };

  return { uploading, error, upload, remove };
};
